import React from 'react'
import styled from 'styled-components'
import { Color, Size } from '../../../../../../const'
import { Button } from '../../../../../shard'
import { Link } from 'react-router-dom'
import _ from 'lodash'

import { useAccountHook } from '../../../../../../hooks'

function AccountEditComplete() {
  const { axios, user, setUser } = useAccountHook()

  if (_.isEmpty(user)) axios.getUser().then(setUser)

  if (!_.isEmpty(user.data)) {
    return <AccountEditCompleteDisplay user={user.data}></AccountEditCompleteDisplay>
  } else {
    return <div></div>
  }
}

function AccountEditCompleteDisplay({ user }) {
  return (
    <AccountBlock>
      <Message>以下の内容で変更しました。</Message>
      <Separator />
      <TextArea>
        <NameLabel>氏名</NameLabel>
        <NameArea>
          <NameWrapper>
            <Name>
              {user.lastname} {user.firstname}
            </Name>
            <Kana>
              {user.lastname_kana} {user.firstname_kana}
            </Kana>
          </NameWrapper>
        </NameArea>
        <GenderLabel>性別</GenderLabel>
        <Gender>{user.gender} </Gender>
        <BirthLabel>生年月日</BirthLabel>
        <Birth>
          {user.birthday_year}年{user.birthday_month}月{user.birthday_day}日
        </Birth>
        <EmailLabel>メールアドレス</EmailLabel>
        <Email>
          {user.mail}@{user.maildomain}
        </Email>
        <TellLabel>連絡先</TellLabel>
        <Tell>{user.phone}</Tell>
        <AddressLabel>住所</AddressLabel>
        <Address>
          〒{user.addresses.address1.zipcode}　{user.addresses.address1.state}
          {user.addresses.address1.city}
          {user.addresses.address1.address1}
          {user.addresses.address1.address2}
          {user.addresses.address1.address3}
        </Address>
      </TextArea>
      <ButtonWrapper>
        <Link to="/account">
          <Button primary type="button">
            アカウント情報へ戻る
          </Button>
        </Link>
      </ButtonWrapper>
    </AccountBlock>
  )
}

const AccountBlock = styled.div`
  padding: 38px 24px 40px 24px;
  border-radius: 10px;
  border: 1px solid ${Color.LINE.NORMAL};
`
const Message = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  padding-bottom: 26px;
  text-align: center;
`
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
  margin: 0;
`
const TextLabel = `
  grid-column: 1;
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
  display: grid;
  align-items: center;
`
const Text = `
  grid-column: 2;
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  display: grid;
  align-items: center;
`
const TextArea = styled.div`
  display: grid;
  grid-template-columns: 137px 1fr;
  grid-template-rows: 84px 84px 84px 84px 84px 84px;
`
let RowNum = 1
const NameLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const NameArea = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
const NameWrapper = styled.div``
const Name = styled.div`
  float: left;
  padding-right: 20px;
`
const Kana = styled.div`
  float: left;
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
  padding-top: 2px;
`
RowNum = 2
const GenderLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const Gender = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
RowNum = 3
const BirthLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const Birth = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
RowNum = 4
const EmailLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const Email = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
RowNum = 5
const TellLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const Tell = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
RowNum = 6
const AddressLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const Address = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 45px;
`

export default AccountEditComplete
